module.exports = __webpack_public_path__ + "img/team_meiyung.4c2b1822.jpg";